// @flow

import * as React from 'react'
import { colors } from '@toggl/style'

export const Email = ({ color = colors.darkPurple }: { color?: string }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill={color}
        d="M0,76v360h512V76H0z M456.953,106L256,281.104L55.047,106H456.953z M30,123.967l151.624,132.12L30,388.058V123.967z M55.081,406l149.378-130.016L256,320.896l51.542-44.912L456.919,406H55.081z M482,388.059L330.376,256.087L482,123.967V388.059z"
      />
    </g>
  </svg>
)
